import { useMatch } from 'react-router-dom';

export const useMatchPath = useMatch;
